const VALID_ANCHOR_TYPES = new Set([
    "bottom-nw",
    "bottom-ne",
    "bottom-sw",
    "bottom-se",
    "center",
    "edge-midpoint",
    "top-center",
    "bottom-center",
    "bottom-start",
    "top-start",
]);
/** Type guard for TAnchorType */
export function isAnchorType(value) {
    return VALID_ANCHOR_TYPES.has(value);
}
//# sourceMappingURL=types.js.map